import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M10.073 13.045H8.087c-.32 0-.42-.12-.42-.421v-2.427c0-.32.12-.421.42-.421h1.986V8.01c0-.802.14-1.564.541-2.266A3.33 3.33 0 0 1 12.4 4.26 4.5 4.5 0 0 1 13.943 4h1.966c.28 0 .4.12.4.401v2.286c0 .281-.12.401-.4.401-.542 0-1.083 0-1.625.02-.541 0-.822.261-.822.823-.02.601 0 1.183 0 1.805h2.326c.321 0 .442.12.442.441v2.427c0 .32-.1.42-.442.42h-2.326v6.539c0 .34-.1.461-.461.461h-2.507c-.301 0-.421-.12-.421-.421z" }, null, -1)
  ])))
}
export default { render: render }